import React from 'react';
import ReactDOM from 'react-dom';
import  Globalstyle from './styles/globalStyles';
import Routes from './routes'



ReactDOM.render(
<>
  <Routes
  />,<Globalstyle />
</>,
document.getElementById("root"));